<template>
    <div id="loading">
        <v-progress-circular
                :size="70"
                :width="7"
                color="#00B8BF"
                indeterminate
        ></v-progress-circular>
    </div>
</template>

<script>
    export default {
        name: 'Loading'
    }
</script>
